module.exports = __webpack_public_path__ + "assets/img/consideration-comment-ged-peut-aider-entreprise.545bbf80.jpg";